import React, { useState } from 'react'
import cn from "../../lib/bem";
import ico_expand from "../../assets/svg/ico_expand.svg";
import ico_close from "../../assets/svg/ico_close.svg";

import './buttonModal_component.scss';

const ButtonModalComponent = (props) => {

    const classes = cn("buttonModalComponent");
    
    const [ mostrarModal, setMostrarModal ] = useState(false);

    return (
        <div className={classes()}>
           {
                mostrarModal &&
                    <div className={classes('buttonModal')}>
                        <div className={classes('buttonContainer')}>
                            <div className={classes('buttonContent')}>
                                <div className={classes('buttonModalClose')} onClick={ () => setMostrarModal(false)}>Cerrar <img src={ico_close} alt={'ico_close'}/></div>
                                <p className={classes('buttonModalTitle')}><b>{props.title}</b></p>
                                {props.body}
                            </div>
                        </div>
                    </div>
           }
            <button type="button" aria-label={props.label} className={classes(props.tipo)} disabled={props.disabled} onClick={() => setMostrarModal(true)}>
                {props.nombre}
                <img src={ico_expand} alt={'ico_expand'}/>
            </button>
        </div>
    )

}

export default ButtonModalComponent
